
define('text!modules/targeting/pixel/templates/bin_title.html',[],function () { return '<div class="header-c title header-{{bin_kind}}" >\n\t<span class="label" data-bind="bin_label">{{bin_label}}:&nbsp;</span>\n\t<span class="count" data-bind="totalLoads">{{totalLoads}}&nbsp;</span>\n\t<div class="icon-spinner"></div>\n</div>';});

